import { BrandStep } from '../../components/wizardModal/brandStep/brandStep';
import { CategoryStep } from '../../components/wizardModal/categoryStep/categoryStep';
import {
  FeelingsStep,
  feelingsStepEnabledForStore,
} from '../../components/wizardModal/feelingsStep/feelingsStep';
import { LineageStep } from '../../components/wizardModal/lineageStep/lineageStep';
import { PriceStep } from '../../components/wizardModal/priceStep/priceStep';
import type { WizardFormData, WizardSteps } from './types';
import { WizardStepKey } from './types';

export const WIZARD_STEPS: WizardSteps = {
  [WizardStepKey.Feelings]: {
    enabledForStore: feelingsStepEnabledForStore,
    filterComponent: FeelingsStep,
    title: 'Effects',
  },
  [WizardStepKey.Category]: {
    filterComponent: CategoryStep,
    title: 'Category',
  },
  [WizardStepKey.Price]: {
    filterComponent: PriceStep,
    title: 'Price range',
  },
  [WizardStepKey.Lineage]: {
    filterComponent: LineageStep,
    title: 'Lineage',
  },
  [WizardStepKey.Brand]: {
    filterComponent: BrandStep,
    title: 'Brand',
  },
};

export const ORDERED_STEP_KEYS: WizardStepKey[] = [
  WizardStepKey.Feelings,
  WizardStepKey.Category,
  WizardStepKey.Price,
  WizardStepKey.Lineage,
  WizardStepKey.Brand,
];

export const INITIAL_WIZARD_FORM_DATA: WizardFormData = {
  [WizardStepKey.Brand]: [],
  [WizardStepKey.Category]: [],
  [WizardStepKey.Feelings]: [],
  [WizardStepKey.Lineage]: [],
  [WizardStepKey.Price]: [],
};
